import { useLocation } from "react-router-dom";

export const Logo = ({ compact = false }) => {
  const { pathname } = useLocation();
  const href = pathname === "/" ? "#top" : "/#top";
  return (
    <a href={href} className="flex items-center gap-2.5 group" data-testid="brand-logo" aria-label="Farmint home">
      <img
        src="/farmint-icon.png"
        alt="Farmint logo"
        className={`${compact ? "h-8 w-8" : "h-9 w-9"} rounded-lg transition-transform duration-300 group-hover:scale-105`}
      />
      <span className={`font-display font-extrabold tracking-tight ${compact ? "text-lg" : "text-xl"}`}>
        Farm<span className="text-primary">i</span>nt
      </span>
    </a>
  );
};
